import { useState } from "react";
import { api } from "../utils/axios-config";
import OtpInput from "react-otp-input";
import OtpTimer from "./OTPTimer";

const SetOTP = ({ phone }) => {
  const [otp, setOtp] = useState("");
  const [btnSubmitFlag, setBtnSubmitFlag] = useState(false);
  const [successMsg, setSuccessMsg] = useState("");
  const [errorMsg, setErrorMsg] = useState("");
  const [needResend, setNeedResend] = useState(false);

  const handleOTPChange = (val) => {
    if (!/^[0-9]*$/.test(val)) return;
    setOtp(val);
    setErrorMsg("");
  };

  const handleSubmitOTP = async () => {
    if (otp.length < 6) return;
    setBtnSubmitFlag(true);
    try {
      let dactivateAccResponse = await api.post(
        "/users/delete-account/confirm",
        {
          phone: `+2${phone}`,
          code: otp,
        }
      );
      if (dactivateAccResponse.status === 200) {
        setSuccessMsg("Ok");
      } else {
        setErrorMsg(dactivateAccResponse?.data?.message);
      }
      setBtnSubmitFlag(false);
    } catch (error) {
      if (error?.response?.data?.errors.length > 0)
        setErrorMsg(error?.response?.data?.errors[0]);
      else if (error?.response?.data?.message)
        setErrorMsg(error?.response?.data?.message);
      else setErrorMsg(error?.response?.data?.msg);
      setBtnSubmitFlag(false);
    }
  };

  const handleResendOtp = async () => {
    try {
      let requestOTPRes = await api.post(`/users/deactivate-account/request`, {
        phone: `+2${phone}`,
      });
      if (requestOTPRes.status === 200) {
        setNeedResend(false);
      }
    } catch (error) {
      if (error?.response?.data?.message)
        setErrorMsg(error?.response?.data?.message);
      else setErrorMsg(error?.response?.data?.msg);
    }
  };

  const handleBackRedirection = () => {
    setErrorMsg("");
    setNeedResend(false);
    setBtnSubmitFlag(false);
    setOtp("");
  };

  return (
    <div className="set-otp-box">
      {!successMsg && !errorMsg && (
        <div className="container">
          <p className="alert-msg">
            Enter your 5-digit code sent to you via SMS on phone number end with{" "}
            {phone.substr(phone.length - 5)}
          </p>
          <div className="otp-box">
            <OtpInput
              containerStyle={{ direction: "ltr" }}
              value={otp}
              onChange={handleOTPChange}
              inputType="tel"
              shouldAutoFocus={true}
              numInputs={6}
              renderSeparator={<span>-</span>}
              renderInput={(props) => <input type="number" {...props} />}
            />
            <div className="otp-note">
              Code expires in 01:30. If you experience problems, we can resend
              the code.
            </div>
            {errorMsg && <p className="error-msg"> {errorMsg}</p>}
            {!needResend && (
              <OtpTimer expirationTime={90} setNeedResend={setNeedResend} />
            )}

            {needResend && (
              <button
                style={{
                  backgroundColor: "rgb(8, 31, 111)",
                  color: "#fff",
                  borderRadius: "18px",
                  padding: "10px 30px",
                  cursor: "pointer",
                  border: 0,
                  opacity: btnSubmitFlag ? "0.5" : "1",
                }}
                className="otp-button"
                onClick={handleResendOtp}
              >
                Resend OTP
              </button>
            )}
            <div
              style={{
                width: "100%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                padding: "20px",
              }}
            >
              <div
                style={{
                  backgroundColor:
                    otp.length === 6
                      ? "rgb(8, 31, 111)"
                      : "rgb(8, 31, 111, 0.5)",
                  color: "#fff",
                  borderRadius: "24px",
                  padding: "6px 30px",
                  cursor: "pointer",
                  opacity: btnSubmitFlag ? "0.5" : "1",
                }}
                onClick={handleSubmitOTP}
              >
                {btnSubmitFlag ? "Please Wait .." : "Submit"}
              </div>
            </div>
          </div>
        </div>
      )}
      {successMsg && (
        <div className="otp-box">
          <div className="container otp">
            <div style={{ marginBottom: "50px" }} className="otp-title">
              Your Insurance Brokerage mobile app account has been deleted
              successfuly.
            </div>
            <img
              src="/success.png"
              alt="success sign"
              style={{ width: "60%" }}
            />
          </div>
        </div>
      )}
      {errorMsg && (
        <div className="otp-box">
          <div className="container otp">
            <div style={{ marginBottom: "50px" }} className="otp-title">
              {errorMsg}
            </div>
            <img src="/sad.svg" alt="failed sign" style={{ width: "40%" }} />
            <div className="btn-back-container">
              <div className="btn-back" onClick={handleBackRedirection}>
                Back
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default SetOTP;
